import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import MDIGITAL_INIT from "./MDIGITAL_INIT";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';
  var onsiteConfiguration;

  function isAllowedDomain(allowedDomains) {
    const originDomain = window.location.hostname;
    const matchedDomains = allowedDomains.filter ? allowedDomains.filter(function (allowedDomain) {
      if (allowedDomain[0] === '*') {
        const testRegex = new RegExp('^.*' + allowedDomain.slice(1) + '$');
        return testRegex.test(originDomain)
      }
      return allowedDomain === originDomain;
    }) : [];
    return !!matchedDomains.length;
  }

  function init() {
    window.MDIGITAL = window.MDIGITAL || {}; // initializing MDIGITAL global object
    var isGenericAlreadyLoaded = !!window.MDIGITAL.version;
    if (isGenericAlreadyLoaded) {
      // Support onsite/non-encapsulation use of MDIGITAL.ANALYTICS
      var MD_ANALYTICS = MDIGITAL_ANALYTICS || window.MDIGITAL.ANALYTICS;
      if (MD_ANALYTICS && {"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled
          && window.MDIGITAL.md_tracker) {
        MD_ANALYTICS.sendDigitalAnalytics({
          eventId: 'MDigital_multipleGenericInjections',
          mdData: {
            additionalInfo: `version ${KAMPYLE_CONSTANT.PLACEHOLDERS.ONSITE_VERSION} was loaded after ${window.MDIGITAL.version}`,
          }
        });
      }
      throw new Error('MDIGITAL already loaded');
    }
    window.MDIGITAL.version = KAMPYLE_CONSTANT.PLACEHOLDERS.ONSITE_VERSION;

    onsiteConfiguration = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    initBaseModules();
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DATA_JSON, onsiteConfiguration);

    const onsiteDataLocation = getOnsiteDataLocation();
    if(!onsiteDataLocation) {
      MDIGITAL_CONFIGURATION.onsiteDataFailed(`onsiteDataLocation is ${onsiteDataLocation}`);
    } else {
      MDIGITAL_CONFIGURATION.fetchOnsiteExternalConfiguration(onsiteDataLocation);
    }
  }

  function getOnsiteDataLocation() {
      const isExtension = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXTENSION_ENABLED);
      if (isExtension) {
          // Encapsulation with Extension: ONSITE_DATA_PATH holds the protocol.
          return onsiteConfiguration.placeholders?.ONSITE_DATA_PATH;
      }
      const isDHH = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DHH);
      return window.KAMPYLE_EMBED.getOnsiteDataLocation(isDHH);
  }

  function initBaseModules(){
    MDIGITAL_LOGGER.init();
    KAMPYLE_EVENT_DISPATCHER.init();
    KAMPYLE_DATA.init();
    MDIGITAL_CONFIGURATION.init();

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
      MDIGITAL_ANALYTICS.initTracker();
      if (!window.KAMPYLE_EMBED) {
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.DIRECT_GENERIC_INJECTION);
      }
    }
  }

  function initOnsite(onsiteConfiguration) {
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ONSITE_DOMAIN_APPROVAL)) {
      var domainsConfig = onsiteConfiguration.domainsConfiguration;
      if (domainsConfig && !domainsConfig.allDomainsAllowed && domainsConfig.domainsNames && !isAllowedDomain(domainsConfig.domainsNames)) {
        console.error('onsite origin domain is not allowed');
        if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
          KAMPYLE_EVENT_DISPATCHER.triggerError({
            errorMessage: window.location.hostname + ' domain was blocked! domainsConfiguration: ' + JSON.stringify(domainsConfig)
          });
        }
        return;
      }
    }
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DATA_JSON, onsiteConfiguration);
    if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
      MDIGITAL_ANALYTICS.registerConfigurationDependentEvents();
      MDIGITAL_ANALYTICS.updateTrackerAnalyticsUrl();
    }
    KAMPYLE_DATA.initOnsiteDefaultState();
    sendDataToExtension();
    KAMPYLE_FUNC.init();
    KAMPYLE_FUNC.startCheckingTargeting();
    MDIGITAL_INIT.reportInitComplete();
  }

  function reportInitComplete() {
    KAMPYLE_UTILS.triggerCustomEvent('neb_OnsiteLoaded');
  }

  function sendDataToExtension() {
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXTENSION_ENABLED)) {
      window.postMessage({
        action: "sendMdExtensionData", propertyId: KAMPYLE_DATA.getPropertyId(), __isDigitalAction: true
      }, document.location.origin);
    }
  }

  export default {
    init: init,
    initOnsite: initOnsite,
    // testing purposes
    reportInitComplete: reportInitComplete,
    isAllowedDomain: isAllowedDomain
  };
